var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('cookies-consent',{on:{"acceptConsent":_vm.settingPreference}}),_c('PreLoading'),_c('RouterView')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }